import type { DashboardSummary } from '@overlayqa/shared';
import { fetchApi } from './client';
import { log } from '@/lib/logger';
import { SCREEN_READ_TIMEOUT_MS } from './requestTimeout';

log.info('[api/dashboard] Module loaded');

export const dashboardApi = {
  summary: (token?: string) => {
    log.info('[api/dashboard] summary');
    return fetchApi<DashboardSummary>('/dashboard/summary', { token, timeoutMs: SCREEN_READ_TIMEOUT_MS });
  },
};
